<template>
  <el-row :gutter="10">
    <el-col :md="12">
      <p>
        <b>Annual Spend</b><br>
        {{ opportunity.worth ? `$${opportunity.worth}` : '-' }}
      </p>

      <p>
        <b>Daily Volume</b><br>
        {{ opportunity.volume ? `${opportunity.volume}` : '-' }}
      </p>

      <p>
        <b>Comments</b><br>
        {{ opportunity.reason || '-' }}
      </p>

      <p>
        <b>Previous Carriers</b><br>
        <template v-if="opportunity.incumbent_carriers.length">
          <el-tag
            v-for="carrier in opportunity.incumbent_carriers"
            :key="carrier.id"
            size="mini"
            class="mr-1"
          >
            {{ carrier.name || carrier.carrier.name }}
          </el-tag>
        </template>

        <template v-else>
          -
        </template>
      </p>

      <p>
        <b>Suggested Carriers</b><br>
        <template v-if="opportunity.suggested_carriers.length">
          <el-tag
            v-for="carrier in opportunity.suggested_carriers"
            :key="carrier.id"
            size="mini"
            class="mr-1"
          >
            {{ carrier.carrier.name }}
          </el-tag>
        </template>

        <template v-else>
          -
        </template>
      </p>

      <p>
        <b>Type of Freight</b><br>
        <template v-if="opportunity.freights.length">
          <el-tag
            v-for="freight in opportunity.freights"
            :key="freight.id"
            size="mini"
            class="mr-1"
          >
            {{ freight.type.desc }}
          </el-tag>
        </template>

        <template v-else>
          -
        </template>
      </p>

      <p>
        <b>Address</b><br>
        <DisplayAddress
          v-if="opportunity.account"
          :lines="[ opportunity.account.address, opportunity.account.suburb ]"
          :locality="opportunity.account.state"
          :postal-code="opportunity.account.postcode"
          country="AU"
        />

        <template v-else>
          -
        </template>
      </p>
    </el-col>
    <el-col :md="12">
      <p>
        <b>Contact</b><br>
        {{ $_.get(opportunity, 'account.contact', '-') || '-' }}
      </p>
      <p>
        <b>Email</b><br>
        <template
          v-if="$_.get(opportunity, 'account.email')"
        >
          <a :href="`mailto:${$_.get(opportunity, 'account.email', '-')}`">{{ $_.get(opportunity, 'account.email', '-') }}</a>
        </template>
        <template v-else>
          -
        </template>
      </p>
      <p>
        <b>Phone</b><br>
        <template
          v-if="$_.get(opportunity, 'account.phone')"
        >
          <a :href="`tel:${$_.get(opportunity, 'account.phone', '-')}`">{{ $_.get(opportunity, 'account.phone', '-') }}</a>
        </template>
        <template v-else>
          -
        </template>
      </p>
      <p>
        <b>Fax</b><br>
        <template
          v-if="$_.get(opportunity, 'account.fax')"
        >
          <a :href="`tel:${$_.get(opportunity, 'account.fax', '-')}`">{{ $_.get(opportunity, 'account.fax', '-') }}</a>
        </template>
        <template v-else>
          -
        </template>
      </p>
    </el-col>
  </el-row>
</template>

<script>
import DisplayAddress from '@/components/Address'

export default {
  components: {
    DisplayAddress
  },
  props: {
    opportunity: {
      type: Object,
      required: true
    }
  }
}
</script>
